(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function setupCartDrawerTrigger(header) {
    const cartLink = header.querySelector('[data-cart-drawer-trigger]');

    if (!cartLink || cartLink.dataset.cartDrawerTriggerBound === 'true') return;

    cartLink.dataset.cartDrawerTriggerBound = 'true';
    cartLink.addEventListener('click', (event) => {
      // The drawer already handles clicks inside #cart-icon-bubble.
      if (event.defaultPrevented) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

      event.preventDefault();
      cartDrawer.open(cartLink);
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      setupCartDrawerTrigger(this);
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      setupCartDrawerTrigger(this);
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tobfun-premium-trust-strip-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tobfun-header-trust-v32')) {
    customElements.define('tobfun-header-trust-v32', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        const generation = this._generation = (this._generation || 0) + 1;
        queueMicrotask(() => {
          if (!this.isConnected || !this._connected || generation !== this._generation) return;
          this._reserved = this.dataset.slotReserved === 'true';
          this._inView = true;
          this._slot = this.querySelector('[data-sale-slot]');
          this._status = this.querySelector('[data-campaign-status]');
          this._note = this.querySelector('[data-countdown-status]');
          const mode = this.dataset.campaignMode || 'auto';
          this._campaigns = Array.from(this.querySelectorAll('[data-campaign]')).map(element => {
            const startText = (element.dataset.start || '').trim();
            const start = startText ? this._parseDate(startText) : -Infinity;
            const end = this._parseDate(element.dataset.end || '');
            const fields = Array.from(element.querySelectorAll('[data-time]'));
            return {
              element, start, end,
              key: element.dataset.campaign,
              eligible: element.dataset.enabled === 'true' && (mode === 'auto' || mode === element.dataset.campaign),
              valid: !Number.isNaN(start) && Number.isFinite(end) && start < end,
              title: element.querySelector('[data-campaign-title]')?.textContent.trim() || '',
              fields,
              hasSeconds: fields.some(field => field.dataset.time === 'seconds'),
              timer: element.querySelector('[role="timer"]')
            };
          });
          this._eligible = this.dataset.countdownEnabled === 'true' ? this._campaigns.filter(item => item.eligible) : [];
          this._onVisibility = () => this._refresh();
          this._onPageShow = () => this._refresh();
          document.addEventListener('visibilitychange', this._onVisibility);
          window.addEventListener('pageshow', this._onPageShow);
          if ('IntersectionObserver' in window) {
            this._observer = new IntersectionObserver(entries => {
              const visible = Boolean(entries[0]?.isIntersecting);
              if (visible !== this._inView) { this._inView = visible; this._refresh(); }
            }, { threshold: 0 });
            this._observer.observe(this);
          }
          this._refresh();
        });
      }

      disconnectedCallback() {
        this._connected = false;
        this._generation = (this._generation || 0) + 1;
        clearTimeout(this._timeout);
        this._observer?.disconnect();
        document.removeEventListener('visibilitychange', this._onVisibility);
        window.removeEventListener('pageshow', this._onPageShow);
        this.dataset.motion = 'paused';
        this.style.setProperty('--tf-motion', 'paused');
      }

      _parseDate(value) {
        const text = String(value).trim().replace(' ', 'T');
        const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(text);
        if (!parts) return NaN;
        const [, year, month, day, hour, minute, second = '0', zone] = parts;
        const daysInMonth = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
        if (Number(year) < 1970 || Number(month) < 1 || Number(month) > 12 || Number(day) < 1 || Number(day) > daysInMonth || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return NaN;
        if (zone !== 'Z') {
          const zoneHour = Number(zone.slice(1, 3)), zoneMinute = Number(zone.slice(4, 6));
          if (zoneHour > 14 || zoneMinute > 59 || (zoneHour === 14 && zoneMinute !== 0)) return NaN;
        }
        return Date.parse(text);
      }

      _setHidden(element, hidden) {
        if (element && element.hidden !== hidden) element.hidden = hidden;
      }

      _refresh() {
        clearTimeout(this._timeout);
        if (!this._connected || !this._campaigns) return;
        const awake = !document.hidden && this._inView;
        const motion = awake ? 'running' : 'paused';
        if (this.dataset.motion !== motion) {
          this.dataset.motion = motion;
          this.style.setProperty('--tf-motion', motion);
        }
        if (!awake) return;
        const now = Date.now();
        const active = this._eligible.find(item => item.valid && now >= item.start && now < item.end);
        const displayed = this._reserved ? active : null;
        this._campaigns.forEach(item => this._setHidden(item.element, item !== displayed));

        if (displayed) {
          const ms = Math.max(0, displayed.end - now);
          const unit = displayed.hasSeconds ? 1000 : 60000;
          const total = Math.ceil(ms / unit) * (unit / 1000);
          const remaining = {
            days: Math.floor(total / 86400),
            hours: Math.floor(total % 86400 / 3600),
            minutes: Math.floor(total % 3600 / 60),
            seconds: total % 60
          };
          displayed.fields.forEach(field => {
            const next = String(remaining[field.dataset.time]).padStart(2, '0');
            if (field.textContent !== next) field.textContent = next;
          });
          const spoken = [displayed.key, remaining.days, remaining.hours, remaining.minutes].join(':');
          if (spoken !== this._spoken) {
            this._spoken = spoken;
            displayed.timer?.setAttribute('aria-label', displayed.title + ': ' + remaining.days + ' days, ' + remaining.hours + ' hours, ' + remaining.minutes + ' minutes remaining');
          }
        }
        if (this.dataset.clockReady !== 'true') this.dataset.clockReady = 'true';
        this._setHidden(this._status, !this._reserved || Boolean(displayed));

        if (this._note) {
          const enabled = this.dataset.countdownEnabled === 'true';
          const invalid = this._eligible.some(item => !item.valid);
          const unavailable = enabled && (!displayed || invalid);
          this._setHidden(this._note, !unavailable);
          if (unavailable) {
            const message = invalid
              ? '请检查活动日期：需包含时区，且开始时间早于截止时间，例如 2026-11-28T00:00:00-05:00。'
              : active && !this._reserved
                ? '首屏未预留活动行。为避免顶动页眉，本次不追加活动行；请保存并重新预览，必要时等待主题缓存更新。'
                : '当前没有处于排期内的活动。未开始/已结束的活动不会在首次加载时占位；正在浏览时结束则保留行高并显示结束提示。';
            if (this._note.textContent !== message) this._note.textContent = message;
          }
        }

        if (!this._reserved) return;
        let delay = Infinity;
        if (displayed) {
          const ms = displayed.end - now;
          const unit = displayed.hasSeconds ? 1000 : 60000;
          const phase = ms % unit;
          delay = Math.min(phase > 1 ? phase : unit, ms);
        }
        this._eligible.forEach(item => {
          if (!item.valid) return;
          if (item.start > now) delay = Math.min(delay, item.start - now);
          if (item.end > now) delay = Math.min(delay, item.end - now);
        });
        if (Number.isFinite(delay)) {
          this._timeout = setTimeout(() => this._refresh(), Math.min(2147483000, Math.max(20, delay + 20)));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
